/** The FresherBot robot, large and very faint, bleeding off the top-left corner behind everything: a watermark, not a header. */
export function Watermark() {
  return (
    <div className="nv-mark" aria-hidden="true">
      <img src="/brand/fresherbot-bot.png" alt="" draggable={false} />
    </div>
  );
}
